module.exports = __webpack_public_path__ + "img/banner_xg.66c7f52d.jpg";